import React, { useRef, useState, useEffect } from 'react';
import Template from '../../component/Template';
import SchoolIcon from '@mui/icons-material/School';
import profile1 from '../../Assets/img/student.jpg';
import Api from "../../component/Api";
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate, useParams } from 'react-router-dom';
import { isArray } from 'jquery';





const StudentProfile = () => {

  const [studentdata, setStudentData] = useState(false);
  const [getStudentSwitchStatData, setStudentSwitchStatData] = useState([]);

  const [update, setupdate] = useState([]);
  const [editableColumns, setEditableColumns] = useState([]);
  const [editColumn, setEditColumn] = useState(null);
  const [profile, setProfile] = useState(null);
  const [courseDetails, setCourseDetails] = useState({});
  const [markDetails, setMarkDetails] = useState([]);


  const [fileToUpload, setFileToUpload] = useState(null); // Track the selected file nov 8

  const { http } = Api();

  const [activecoTab, setActiveCoTab] = useState('tab1');


  const [activeTab, setActiveTab] = useState('personal');

  const [tabRows, setTabRows] = useState({
    tab1: [{ id: 1 }],
    tab2: [{ id: 1 }],
    tab3: [{ id: 1 }],
    tab4: [{ id: 1 }],
    tab5: [{ id: 1 }],
    tab6: [{ id: 1 }],
    tab7: [{ id: 1 }],
    tab8: [{ id: 1 }]
  });


  const navigate = useNavigate();

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  const getCoursesForActiveSemester = () => {

    if (courseDetails.semester && courseDetails.semester[activecoTab.slice(-1)]) {
      return courseDetails.semester[activecoTab.slice(-1)];
    }

    return [];
  };


  let { id } = useParams();
  const decodedID = atob(id);

  useEffect(() => {
    const studentdata = async () => {

      try {
        const response = await http.get(`/College/viewStudentProfile`, {
          params: {
            accountId: decodedID
          }
        })

        setStudentData(response.data.studentdata[0]);
        setStudentSwitchStatData(response.data.studentdata[0].switch_stat);
        setProfile(response.data.studentdata[0].studentphoto.original.base64_image);
        setupdate(response.data.updatefileds);
        setMarkDetails(response.data.markdetails);
        const coursesBySemester = {};

        if (response.data.coursedetails) {

          Object.keys(response.data.coursedetails.semester).forEach(key => {
            const courses = response.data.coursedetails.semester[key];
            if (!coursesBySemester[key]) {
              coursesBySemester[key] = [];
            }
            coursesBySemester[key] = courses;
          });
        }


        setTabRows({
          tab1: coursesBySemester[1] || [],
          tab2: coursesBySemester[2] || [],
          tab3: coursesBySemester[3] || [],
          tab4: coursesBySemester[4] || [],
          tab5: coursesBySemester[5] || [],
          tab6: coursesBySemester[6] || [],
          tab7: coursesBySemester[7] || [],
          tab8: coursesBySemester[8] || [],
        });

      } catch (error) {
        if (error.response.data.http_status === 401) {
          toast.error("Invalid token");
          setTimeout(() => {
            navigate('/');
          }, 5000);
        } else {
          toast.error("Error fetching Student data");
          console.error('Error fetching Student data:', error);
        }


      }
    };
    studentdata();
  }, [editColumn]);


  useEffect(() => {
    if (Array.isArray(update)) {
      // Extract the column names with 'active' status from server response
      const activeColumns = update
        .filter(col => col.status === 'active')
        .map(col => col.column_name);

      setEditableColumns(activeColumns);
    } else {
      // Handle the case where `update` is undefined or not an array
      console.error('The "update" variable is not an array or is undefined.');
      setEditableColumns([]); // Set to an empty array to avoid further issues
    }
  }, [update]);



  const handleEditClick = (column) => {
    setEditColumn(column);

  };

  const handleInputChange = (e) => {
    setStudentData({
      ...studentdata,
      [e.target.name]: e.target.value
    });
  };

  const isValidEmail = (value) => {
    // Regular expression for email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(value);
  };


  {/*12nov2024*/ }
  const isValidMobileNumber = (value) => {
    // Regular expression for 10-digit mobile number validation
    const mobileNumberRegex = /^\d{10}$/;
    return mobileNumberRegex.test(value);
  };
  {/*12nov2024*/ }


  const handleEdit = (name) => {

    let validation = true;
    let validationmsg = "";

    if (name === "apaar_no") {
      if (!/^\d{12}$/.test(studentdata[name])) {
        validation = false;
        validationmsg = "The apaar no field must be 12 digits.";
      }
    }
    if (name === "aadhar_no") {
      if (!/^\d{12}$/.test(studentdata[name])) {
        validation = false;
        validationmsg = "The aadhar no field must be 12 digits.";
      }
    }

    if (name === "student_email") {
      if (!isValidEmail(studentdata[name])) {
        validation = false;
        validationmsg = "The Email is not valid.";
      }
    }

    if (name === "student_dob") {

      const dateValue = new Date(studentdata[name]);
      if (isNaN(Date.parse(studentdata[name])) || dateValue > new Date()) {
        validation = false;
        validationmsg = "Date of Birth is not valid."
      }
    }

    if (name === "student_sex") {

      const validSexValues = ["m", "f", "o"];
      if (!validSexValues.includes(studentdata[name].toLowerCase())) {
        validation = false;
        validationmsg = "Gender is not valid. Please use 'm', 'f', or 'o'.";

      }
    }
    {/*12nov2024*/ }
    if (name === "student_mobile_no") {
      if (!isValidMobileNumber(studentdata[name])) {
        validation = false;
        validationmsg = "The Mobile Number is not valid.";
      }
    }
    {/*12nov2024*/ }

    {/*13nov2024*/ }
    if (name === "studentname") {
      if (studentdata[name] == '') {
        validation = false;
        validationmsg = "Please enter a valid name";
      }
    }
    {/*13nov2024*/ }


    if (validation) {

      http.post('College/updateStudentDetails',
        {
          accountId: studentdata['accountid'],
          [name]: studentdata[name]
        }).then(response => {

          if (response.data.http_status === 200) {
            toast.success(`${name} Updated Successfully`);
            setEditColumn('');

          }

        }).catch(error => {
          if (error.response.data.http_status === 401 && error.response.data.status_code == "ERR9") {
            toast.error("Invalid Token");
            setTimeout(() => {
              navigate("/college/");

            }, 5000);
          }
          else if (error.response.data.http_status === 422 && error.response.data.status_code == "ERR1") {
            toast.error("Validation Failed");

          }
          else if (error.response.data.http_status === 401 && error.response.data.status_code == "ERR43") {
            toast.error("Email ID already exists");

          }
          else if (error.response.data.http_status === 401 && error.response.data.status_code == "ERR44") {
            toast.error("Apaar number already exists");

          }
          else if (error.response.data.http_status === 401 && error.response.data.status_code == "ERR45") {
            toast.error("Aadhar number already exists");

          }
          else {
            toast.error("something went wrong");
            setTimeout(() => {
              window.location.reload();
            }, 1000); // 5000 milliseconds = 5 seconds
          }
        })

    } else {
      toast.error(validationmsg);
    }
  };


  const handleClose = () => {

    setEditColumn('');

  }



  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = String(date.getFullYear());
    // const year = String(date.getFullYear()).slice(-2);
    return `${day}-${month}-${year}`;
  };
  //convert year only
  const fullYear = (dateString) => {
    const date = new Date(dateString);
    const year = String(date.getFullYear());
    return year;
  };

  const [showModal, setShowModal] = useState(false); // Modal visibility state
  const [nameToEdit, setNameToEdit] = useState('');

  const handleClose1 = () => {
    setShowModal(false);
    setEditColumn('');
  }

  const handleShow = (name) => {
    setNameToEdit(name);  // Set the name being edited
    setShowModal(true);   // Show modal
  };

  const confirmEdit = () => {
    handleEdit(nameToEdit);  // Proceed with edit on confirmation
    setShowModal(false);     // Close modal after confirmation
  };

  const handleCoTabClick = (tab) => {
    setActiveCoTab(tab);
  };

  //nov 8 start
  const fileInputRef = useRef(null);
  const handleProfileImageClick = () => {
    fileInputRef.current.click(); // Trigger file input on image click
  };
  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;


    // Validate file type
    const validFileTypes = ['image/png', 'image/jpeg', 'image/jpg'];
    if (!validFileTypes.includes(file.type)) {
      toast.error('Only PNG, JPEG, or JPG files are allowed.');
      return;
    }

    // Validate file size
    const fileSizeKB = file.size / 1024;
    if (fileSizeKB < 15 || fileSizeKB > 200) {
      toast.error('File size must be between 15 KB and 200 KB.');
      return;
    }

    // Validate file resolution
    const image = new Image();
    image.onload = async () => {
      const { width, height } = image;
      if (width !== 160 || height !== 200) {
        toast.error('Image resolution must be 160x200 pixels.');
        return;
      }
      // Ask for confirmation before uploading
      const confirmUpload = window.confirm("Are you sure you want to upload this photo?");
      if (confirmUpload) {
        setFileToUpload(file); // Set file for upload if confirmed
        uploadPhoto(file); // Call the upload API
      }
    };
    image.src = URL.createObjectURL(file); // Load image dimensions
  };

  const uploadPhoto = async (file) => {
    const formData = new FormData();
    formData.append('image', file);

    try {
      const response = await http.post('/College/photoUpload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        params: {
          accountId: decodedID
        }
      });
      toast.success('Profile photo updated successfully!');

      setTimeout(() => {
        navigate("/college/studentprofile");
      }, 2000);

      //setProfile(response.data.newProfileImage); // Update the profile image
      // Refresh the page after successful upload
      window.location.reload();
    } catch (error) {
      toast.error('Error uploading profile photo');
      console.error('Error uploading profile photo:', error);
    }
  };
  //nov 8 end

  const [isAccordionOpen, setAccordionOpen] = useState(false);

  const toggleAccordion = () => {
    setAccordionOpen(!isAccordionOpen);
  };

  return (
    <>
      <ToastContainer />
      <Template>
        <div className="container-fluid">

          <div className={`modal fade show ${showModal ? 'd-block' : ''}`} id="exampleModalCenter1" tabIndex="-1" role="dialog" aria-labelledby="exampleModalCenter1" aria-model="true" style={{ backdropFilter: 'blur(2px)' }}>
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content">
                <div className="modal-body">
                  <div className="modal-toggle-wrapper">

                    <h4 className="text-center pb-2">Are you sure you want to update ?</h4>
                    <div className="d-flex justify-content-center mt-3">

                      <button className="btn btn-danger mx-2" onClick={confirmEdit}>Update</button>
                      <button className="btn " style={{ backgroundColor: 'white', borderColor: 'red', color: 'black' }} data-bs-dismiss="modal" onClick={() => handleClose1()}>Cancel</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {studentdata ? (
            <>
              <div className="row">
                <div className="col-xl-4 col-sm-4 col-xxl-3">
                  <div className="card card1">
                    <div className="card-header">
                      <h4 className="card-title mb-0">My Profile</h4>
                    </div>
                    <div className="card-body">
                      <div className="social-img-wrap col-st-image-wrap">
                        {/* <div className="social-img col-st-image-prof">
                          <img src={profile}// Prepend the base64 value with the MIME type
                            alt="profile"
                            className="prof-img-ht zoom-img" />
                        </div> */}
                        {/** Nov 8 start */}
                        <div
                          className="social-img col-st-image-prof"
                          onClick={editableColumns.includes('studentphoto') ? handleProfileImageClick : null}
                          style={{ cursor: editableColumns.includes('studentphoto') ? 'pointer' : 'default' }}
                        >
                          <img src={profile}// Prepend the base64 value with the MIME type
                            alt="profile"
                            className="prof-img-ht zoom-img" />
                          {editableColumns.includes('studentphoto') && (
                            <button
                              onClick={handleProfileImageClick}
                              style={{
                                position: 'absolute',
                                top: '0',
                                right: '0',
                                background: 'none',
                                border: 'none',
                                cursor: 'pointer'
                              }}
                            >
                              <i className="fas fa-edit"></i>
                            </button>
                          )}
                        </div>
                        <input
                          type="file"
                          ref={fileInputRef}
                          style={{ display: 'none' }} // Hidden file input
                          onChange={handleFileChange} // Handle file change event
                        />

                        {/** Nov 8 end */}

                        <div className="edit-icon col-img-rt">
                          {studentdata.status === 'active' && (
                            <svg className="st-act-btn">
                              <use href="../assets/svg/icon-sprite.svg#profile-check"></use>
                            </svg>
                          )}
                        </div>
                      </div>

                      <div className="social-details">
                        <div className="media-body prof-bak-clr">
                          {/*13nov2024*/}
                          {editableColumns.includes('studentname') ? (
                            <>
                              {/* <h5 className="mb-1 s-pdg1">{studentdata.studentname}</h5> */}
                              {editColumn === 'studentname' ? (
                                <>
                                  <input
                                    type="text"
                                    name="studentname"
                                    value={studentdata.studentname}
                                    onChange={handleInputChange}
                                    className="form-control"
                                  />
                                  <button
                                    onClick={() => handleShow('studentname')}
                                    style={{
                                      marginLeft: '10px',
                                      background: 'none',
                                      border: 'none',
                                      cursor: 'pointer'
                                    }}
                                  >
                                    <i className="fa fa-check" aria-hidden="true"></i>
                                  </button>

                                  <button
                                    onClick={() => handleClose()}
                                    style={{
                                      marginLeft: '10px',
                                      background: 'none',
                                      border: 'none',
                                      cursor: 'pointer'
                                    }}
                                  >
                                    <i className="fa fa-close" aria-hidden="true"></i>
                                  </button>
                                </>
                              ) : (
                                <>
                                  {studentdata.studentname}
                                  <button
                                    onClick={() => handleEditClick('studentname')}
                                    style={{
                                      marginLeft: '10px',
                                      background: 'none',
                                      border: 'none',
                                      cursor: 'pointer'
                                    }}
                                  >
                                    <i className="fas fa-edit"></i>
                                  </button>
                                </>
                              )}
                            </>
                          ) : (
                            <h5 className="mb-1 s-pdg1">{studentdata.studentname}</h5>
                          )}
                          {/* end 13nov2024 */}

                          <div className="lang s-pdg1">
                            <i className="fa fa-info-circle"></i>
                            <span className="lang-txt">{studentdata.accountid}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>


                <div className="col-xl-8 col-sm-8 col-xxl-9">
                  <div className="card">
                    <div className="card-header">
                      <h4 className="card-title mb-0">Basic Details</h4>
                    </div>

                    <div className="card-body">
                      <div className="card-body pt-0 activity-scroll-container activity-scroll-bar-container clg-card-ht1">

                        <div className="table-responsive">
                          <table className="table table-striped">
                            <tbody className="tab-bor-n">
                              {studentdata.PRN ? (
                                <tr>
                                  <th scope="row">Student ID-PRN</th>
                                  <td>:</td>
                                  <td>{studentdata.PRN}</td>
                                </tr>
                              ) : null}

                              <tr>
                                <th scope="row">Admission Year</th>
                                <td>:</td>
                                <td>{studentdata.admissionyear}</td>
                              </tr>

                              {editableColumns.includes('apaar_no') ? (
                                <tr>
                                  <th scope="row">APAAR. No:</th>
                                  <td>:</td>
                                  <td style={{ display: 'flex', alignItems: 'center' }}>
                                    {editColumn === 'apaar_no' ? (
                                      <>
                                        <input
                                          type="text"
                                          name="apaar_no"
                                          value={studentdata.apaar_no}
                                          onChange={handleInputChange}
                                          className="form-control"
                                        />
                                        <button
                                          onClick={() => handleShow('apaar_no')}// Ensure handleSave is properly implemented
                                          style={{
                                            marginLeft: '10px',
                                            background: 'none',
                                            border: 'none',
                                            cursor: 'pointer'
                                          }}
                                        >
                                          <i className="fa fa-check" aria-hidden="true"></i>
                                        </button>

                                        <button
                                          onClick={() => handleClose()}// Ensure handleSave is properly implemented
                                          style={{
                                            marginLeft: '10px',
                                            background: 'none',
                                            border: 'none',
                                            cursor: 'pointer'
                                          }}
                                        >
                                          <i className="fa fa-close" aria-hidden="true"></i>
                                        </button>
                                      </>
                                    ) : (
                                      <>
                                        {studentdata.apaar_no}
                                        <button
                                          onClick={() => handleEditClick('apaar_no')}
                                          style={{
                                            marginLeft: '10px',
                                            background: 'none',
                                            border: 'none',
                                            cursor: 'pointer'
                                          }}
                                        >
                                          <i className="fas fa-edit"></i>
                                        </button>
                                      </>
                                    )}
                                  </td>
                                </tr>
                              ) : (
                                <tr>
                                  <th scope="row">APAAR. No:</th>
                                  <td>:</td>
                                  <td>{studentdata.apaar_no}</td>
                                </tr>
                              )}

                              {editableColumns.includes('student_sex') ? (
                                <tr>
                                  <th scope="row">Gender</th>
                                  <td>:</td>
                                  <td style={{ display: 'flex', alignItems: 'center' }}>
                                    {editColumn === 'student_sex' ? (
                                      <>
                                        <select
                                          name="student_sex"
                                          value={studentdata.student_sex}
                                          onChange={handleInputChange}
                                          className="form-control"
                                        >
                                          <option value="M">Male</option>
                                          <option value="F">Female</option>
                                          <option value="O">Other</option>
                                        </select>
                                        <button
                                          onClick={() => handleShow('student_sex')}// Ensure handleSave is properly implemented
                                          style={{
                                            marginLeft: '10px',
                                            background: 'none',
                                            border: 'none',
                                            cursor: 'pointer'
                                          }}
                                        >
                                          <i className="fa fa-check" aria-hidden="true"></i>
                                        </button>
                                        <button
                                          onClick={() => handleClose()}// Ensure handleSave is properly implemented
                                          style={{
                                            marginLeft: '10px',
                                            background: 'none',
                                            border: 'none',
                                            cursor: 'pointer'
                                          }}
                                        >
                                          <i className="fa fa-close" aria-hidden="true"></i>
                                        </button>
                                      </>
                                    ) : (
                                      <>
                                        {studentdata.student_sex}
                                        <button
                                          onClick={() => handleEditClick('student_sex')}
                                          style={{
                                            marginLeft: '10px',
                                            background: 'none',
                                            border: 'none',
                                            cursor: 'pointer'
                                          }}
                                        >
                                          <i className="fas fa-edit"></i>
                                        </button>
                                      </>
                                    )}
                                  </td>
                                </tr>
                              ) : (
                                <tr>
                                  <th scope="row">Gender</th>
                                  <td>:</td>
                                  <td>{studentdata.student_sex}</td>
                                </tr>
                              )}

                              <tr>
                                <th scope="row">Age</th>
                                <td>:</td>
                                <td> {studentdata.age ? `${studentdata.age} Yrs` : ''}</td>
                              </tr>

                              {editableColumns.includes('student_dob') ? (
                                <tr>
                                  <th scope="row">Date of Birth (DD-MM-YYYY)</th>
                                  <td>:</td>
                                  <td style={{ display: 'flex', alignItems: 'center' }}>
                                    {editColumn === 'student_dob' ? (
                                      <>
                                        <input
                                          type="date"
                                          name="student_dob"
                                          defaultValue={studentdata.studentdob}
                                          onChange={handleInputChange}
                                          className="form-control"
                                        />
                                        <button
                                          onClick={() => handleShow('student_dob')}// Ensure handleSave is properly implemented
                                          style={{
                                            marginLeft: '10px',
                                            background: 'none',
                                            border: 'none',
                                            cursor: 'pointer'
                                          }}
                                        >
                                          <i className="fa fa-check" aria-hidden="true"></i>
                                        </button>
                                        <button
                                          onClick={() => handleClose()}// Ensure handleSave is properly implemented
                                          style={{
                                            marginLeft: '10px',
                                            background: 'none',
                                            border: 'none',
                                            cursor: 'pointer'
                                          }}
                                        >
                                          <i className="fa fa-close" aria-hidden="true"></i>
                                        </button>
                                      </>
                                    ) : (
                                      <>
                                        {studentdata.student_dob}
                                        <button
                                          onClick={() => handleEditClick('student_dob')}
                                          style={{
                                            marginLeft: '10px',
                                            background: 'none',
                                            border: 'none',
                                            cursor: 'pointer'
                                          }}
                                        >
                                          <i className="fas fa-edit"></i>
                                        </button>
                                      </>
                                    )}
                                  </td>
                                </tr>
                              ) : (
                                <tr>
                                  <th scope="row">Date of Birth</th>
                                  <td>:</td>
                                  <td>{studentdata.student_dob}</td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>



              <div className="row">

                <div className="col-xl-6 col-md-6 col-sm-7">
                  <div className="card">
                    <div className="card-header">
                      <h4>General Information</h4>

                    </div>
                    <div className="card-body">
                      <div className="card-body pt-0 activity-scroll-container activity-scroll-bar-container clg-card-ht3">

                        <div class="table-responsive scroll-y">

                          <ul
                            className="nav nav-tabs border-tab border-0 mb-0 nav-danger"
                            role="tablist"
                            style={{ display: 'flex', justifyContent: 'space-between', padding: 0, margin: 0 }}
                          >
                            <li
                              className="nav-item"
                              style={{ flex: 1 }}
                            >
                              <button
                                className={`nav-link ${activeTab === 'personal' ? 'active' : ''} nav-border pt-0 txt-danger nav-danger`}
                                onClick={() => handleTabClick('personal')}
                                type="button"
                                style={{ width: '100%', textAlign: 'center' }}
                              >
                                <i className="icofont icofont-man-in-glasses"></i> Personal
                              </button>
                            </li>
                            <li
                              className="nav-item"
                              style={{ flex: 1 }}
                            >
                              <button
                                className={`nav-link ${activeTab === 'communication' ? 'active' : ''} nav-border txt-danger nav-danger`}
                                onClick={() => handleTabClick('communication')}
                                type="button"
                                style={{ width: '100%', textAlign: 'center' }}
                              >
                                <i className="icofont icofont-file-document"></i> Communication
                              </button>
                            </li>
                          </ul>

                          <div className="tab-content tab-bor-n" style={{ padding: "0px" }}>
                            <div className={`tab-pane fade ${activeTab === 'personal' ? 'show active' : ''}`} role="tabpanel">
                              <div className="card-body px-0 pb-0">

                                <div className="user-content">
                                  <div className="table-responsive scroll-y">
                                    <table className="table mb-0  table-striped">
                                      <tbody className="tab-bor-n">
                                        {editableColumns.includes('aadhar_no') ? (
                                          <tr>
                                            <th scope="row">Aadhar No:</th>
                                            <td>:</td>
                                            <td style={{ display: 'flex', alignItems: 'center' }}>
                                              {editColumn === 'aadhar_no' ? (
                                                <>
                                                  <input
                                                    type="text"
                                                    name="aadhar_no"
                                                    defaultValue={studentdata.aadhar_no}
                                                    className="form-control mb-2"
                                                    onChange={handleInputChange} // Ensure you handle input change
                                                  />
                                                  <button
                                                    onClick={() => handleShow('aadhar_no')}
                                                    style={{
                                                      marginLeft: '10px',
                                                      background: 'none',
                                                      border: 'none',
                                                      cursor: 'pointer'
                                                    }}
                                                  >
                                                    <i className="fa fa-check" aria-hidden="true"></i>
                                                  </button>
                                                  <button
                                                    onClick={() => handleClose()}// Ensure handleSave is properly implemented
                                                    style={{
                                                      marginLeft: '10px',
                                                      background: 'none',
                                                      border: 'none',
                                                      cursor: 'pointer'
                                                    }}
                                                  >
                                                    <i className="fa fa-close" aria-hidden="true"></i>
                                                  </button>
                                                </>
                                              ) : (
                                                <>
                                                  {studentdata.aadhar_no}
                                                  <button
                                                    onClick={() => handleEditClick('aadhar_no')}
                                                    style={{
                                                      marginLeft: '10px',
                                                      background: 'none',
                                                      border: 'none',
                                                      cursor: 'pointer'
                                                    }}
                                                  >
                                                    <i className="fas fa-edit"></i>
                                                  </button>
                                                </>
                                              )}
                                            </td>
                                          </tr>
                                        ) : (
                                          <tr>
                                            <th scope="row">Aadhar No:</th>
                                            <td>:</td>
                                            <td>{studentdata.aadhar_no}</td>
                                          </tr>
                                        )}



                                        <tr>
                                          <th scope="row">Religion</th>
                                          <td>:</td>
                                          <td>{studentdata.religion_name}</td>

                                        </tr>
                                        <tr>
                                          <th scope="row">Caste</th>
                                          <td>:</td>
                                          <td>{studentdata.caste_name}</td>

                                        </tr>
                                        {/* <tr>
                                    <th scope="row">Nationality</th>
                                    <th>{studentdata.sdid}</th>

                                  </tr> */}
                                        <tr>
                                          <th scope="row">Name of Guardian</th>
                                          <td>:</td>
                                          <td>{studentdata.student_guardian}</td>

                                        </tr>
                                        {/* <tr>
                                    <th scope="row">Relationship</th>
                                    <th>{studentdata.sdid}</th>

                                  </tr> */}
                                        <tr>
                                          <th scope="row">Annual Income</th>
                                          <td>:</td>
                                          <td>{studentdata.annualincome}/-</td>

                                        </tr>
                                        <tr>
                                          <th scope="row"></th>
                                          <td></td>
                                          <td></td>

                                        </tr>

                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className={`tab-pane fade ${activeTab === 'communication' ? 'show active' : ''}`} role="tabpanel">
                              <div className="card-body px-0 pb-0">

                                <div className="user-content">
                                  <div className="table-responsive">
                                    <table className="table mb-0 table-striped">
                                      <tbody>

                                        {editableColumns.includes('student_email') ? (
                                          <tr>
                                            <th scope="row" width="30%">Email</th>
                                            <td>:</td>
                                            <td style={{ display: 'flex', alignItems: 'center' }}>
                                              {editColumn === 'student_email' ? (
                                                <>
                                                  <input
                                                    type="email"
                                                    name="student_email"
                                                    defaultValue={studentdata.student_email}
                                                    className="form-control mb-2" // Added class for consistent styling
                                                    onChange={handleInputChange} // Ensure you handle input change
                                                  />
                                                  <button
                                                    onClick={() => handleShow('student_email')}
                                                    style={{
                                                      marginLeft: '10px',
                                                      background: 'none',
                                                      border: 'none',
                                                      cursor: 'pointer'
                                                    }}
                                                  >
                                                    <i className="fa fa-check" aria-hidden="true"></i>
                                                  </button>
                                                  <button
                                                    onClick={() => handleClose()}// Ensure handleSave is properly implemented
                                                    style={{
                                                      marginLeft: '10px',
                                                      background: 'none',
                                                      border: 'none',
                                                      cursor: 'pointer'
                                                    }}
                                                  >
                                                    <i className="fa fa-close" aria-hidden="true"></i>
                                                  </button>
                                                </>
                                              ) : (
                                                <>
                                                  {studentdata.student_email}
                                                  <button
                                                    onClick={() => handleEditClick('student_email')}
                                                    style={{
                                                      marginLeft: '10px',
                                                      background: 'none',
                                                      border: 'none',
                                                      cursor: 'pointer'
                                                    }}
                                                  >
                                                    <i className="fas fa-edit"></i>
                                                  </button>
                                                </>
                                              )}
                                            </td>
                                          </tr>
                                        ) : (
                                          <tr>
                                            <th scope="row" width="30%">Email</th>
                                            <td>:</td>
                                            <td>{studentdata.student_email}</td>
                                          </tr>
                                        )}
                                        {/*12nov2024*/}
                                        {editableColumns.includes('student_mobile_no') ? (
                                          <tr>
                                            <th scope="row">Phone No.</th>
                                            <td>:</td>
                                            <td style={{ display: 'flex', alignItems: 'center' }}>
                                              {editColumn === 'student_mobile_no' ? (
                                                <>
                                                  <input
                                                    type="text"
                                                    name="student_mobile_no"
                                                    value={studentdata.student_mobile_no}
                                                    onChange={handleInputChange}
                                                    className="form-control"
                                                  />
                                                  <button
                                                    onClick={() => handleShow('student_mobile_no')}// Ensure handleSave is properly implemented
                                                    style={{
                                                      marginLeft: '10px',
                                                      background: 'none',
                                                      border: 'none',
                                                      cursor: 'pointer'
                                                    }}
                                                  >
                                                    <i className="fa fa-check" aria-hidden="true"></i>
                                                  </button>

                                                  <button
                                                    onClick={() => handleClose()}// Ensure handleSave is properly implemented
                                                    style={{
                                                      marginLeft: '10px',
                                                      background: 'none',
                                                      border: 'none',
                                                      cursor: 'pointer'
                                                    }}
                                                  >
                                                    <i className="fa fa-close" aria-hidden="true"></i>
                                                  </button>
                                                </>
                                              ) : (
                                                <>
                                                  {studentdata.student_mobile_no}
                                                  <button
                                                    onClick={() => handleEditClick('student_mobile_no')}
                                                    style={{
                                                      marginLeft: '10px',
                                                      background: 'none',
                                                      border: 'none',
                                                      cursor: 'pointer'
                                                    }}
                                                  >
                                                    <i className="fas fa-edit"></i>
                                                  </button>
                                                </>
                                              )}
                                            </td>
                                          </tr>
                                        ) : (
                                          <tr>
                                            <th scope="row">Phone No.</th>
                                            <td>:</td>
                                            <td>{studentdata.student_mobile_no}</td>

                                          </tr>
                                        )}
                                        {/*12nov2024-end*/}

                                        <tr>
                                          <th scope="row">House Name</th>
                                          <td>:</td>
                                          <td>{studentdata.student_housename}</td>

                                        </tr>
                                        <tr>
                                          <th scope="row">Street/Area</th>
                                          <td>:</td>
                                          <td>{studentdata.student_place}</td>

                                        </tr>
                                        <tr>
                                          <th scope="row">District/Pincode</th>
                                          <td>:</td>
                                          <td>{studentdata.district_name}-{studentdata.student_pin}</td>

                                        </tr>
                                        <tr>
                                          <th scope="row">State</th>
                                          <td>:</td>
                                          <td>{studentdata.state}</td>

                                        </tr>
                                        <tr>
                                          <th scope="row">District</th>
                                          <td>:</td>
                                          <td>{studentdata.district_name}</td>

                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>




                <div className="col-xl-6 col-md-6 col-sm-5">
                  <div className="card">
                    <div className="card-header">
                      <h4 className="card-title mb-0">Academic Details</h4>
                    </div>

                    <div class="card-body">
                      <div className="card-body pt-0 activity-scroll-container activity-scroll-bar-container clg-card-ht3">

                        <div class="table-responsive scroll-y">
                          <table class="table table-striped">
                            <tbody className="tab-bor-n">
                              {getStudentSwitchStatData && (getStudentSwitchStatData === 'college_transfer_only' || getStudentSwitchStatData === 'major_college_change') ? (

                                <>
                                  <tr>
                                    <th width="40%">Admitted College Name</th>
                                    <td>:</td>
                                    <td>{studentdata.college_name}</td>
                                  </tr>

                                  <tr>
                                    <th scope="row">Transferred to</th>
                                    <td>:</td>
                                    <td><b className="transferred-highlight transfer-txt">{studentdata.switched_college_name}</b></td>

                                  </tr>
                                </>
                              ) : (

                                <tr>
                                  <th width="40%">College Name</th>
                                  <td>:</td>
                                  <td>{studentdata.college_name}</td>
                                </tr>

                              )}
                              {/* <tr>
                                <th width="40%">College Name</th>
                                <td>:</td>
                                <td>{studentdata.college_name}</td>

                              </tr> */}
                              <tr>
                                <th>Major Course Type</th>
                                <td>:</td>
                                <td>{studentdata.college_course_type}</td>

                              </tr>
                              <tr>
                                <th scope="row">Application No.</th>
                                <td>:</td>
                                <td>{studentdata.student_application_no}</td>

                              </tr>

                              <tr>
                                <th scope="row">Admitted Programme</th>
                                <td>:</td>
                                <td>{studentdata.specialisation_display_name}</td>

                              </tr>
                              {getStudentSwitchStatData && (getStudentSwitchStatData === 'major_change_only' || getStudentSwitchStatData === 'major_college_change') && (

                                <tr>
                                  <th scope="row">Switched Programme</th>
                                  <td>:</td>
                                  <td><b className="transferred-highlight transfer-txt">{studentdata.switched_major_name}</b></td>

                                </tr>
                              )}
                              <tr>
                                <th scope="row">Semester</th>
                                <td>:</td>
                                <td>{studentdata.currentsemester}</td>

                              </tr>

                              <tr>
                                <th scope="row">Year</th>
                                <td>:</td>
                                <td>{fullYear(studentdata.register_datetime)}</td>

                              </tr>

                              <tr>
                                <th scope="row">Admitted quota</th>
                                <td>:</td>
                                <td>{studentdata.admittedquota}</td>

                              </tr>

                              <tr>
                                <th scope="row">Reservation Category</th>
                                <td>:</td>
                                <td>{studentdata.reservation_name}</td>

                              </tr>


                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>



              <div className="col-xxl-12 col-xl-12 box-col-4 m-b-0">
                <div className="col-sm-12">
                  <div className="card tranaction-card">
                    <div className="card-header card-no-border">
                      <div className="header-top">
                        <h5>Semester wise course information</h5>
                        <div className="st-dash-sem-tab">
                          <ul className="nav nav-tabs custom-tab" id="myTab" role="tablist">
                            <li className="nav-item nav-item-clr" role="presentation">
                              <button
                                className={`nav-link nav-link-clr ${activecoTab === 'tab1' ? 'active' : ''}`}
                                id="all-tab"
                                type="button"
                                role="tab"
                                onClick={() => handleCoTabClick('tab1')}
                              >
                                Sem 1
                              </button>
                            </li>
                            <li className="nav-item" role="presentation">
                              <button
                                className={`nav-link br1 nav-link-clr ${activecoTab === 'tab2' ? 'active' : ''}`}
                                id="buy-tab"
                                type="button"
                                role="tab"
                                onClick={() => handleCoTabClick('tab2')}

                              >
                                Sem 2
                              </button>
                            </li>
                            <li className="nav-item" role="presentation">
                              <button
                                className={`nav-link br1 nav-link-clr ${activecoTab === 'tab3' ? 'active' : ''}`}
                                id="sell-tab"
                                type="button"
                                role="tab"
                                onClick={() => handleCoTabClick('tab3')}

                              >
                                Sem 3
                              </button>
                            </li>
                            <li className="nav-item" role="presentation">
                              <button
                                className={`nav-link br1 nav-link-clr ${activecoTab === 'tab4' ? 'active' : ''}`}
                                id="sell-tab"
                                type="button"
                                role="tab"
                                onClick={() => handleCoTabClick('tab4')}

                              >
                                Sem 4
                              </button>
                            </li>
                            <li className="nav-item" role="presentation">
                              <button
                                className={`nav-link br1 nav-link-clr ${activecoTab === 'tab5' ? 'active' : ''}`}
                                id="sell-tab"
                                type="button"
                                role="tab"
                                onClick={() => handleCoTabClick('tab5')}

                              >
                                Sem 5
                              </button>
                            </li>
                            <li className="nav-item" role="presentation">
                              <button
                                className={`nav-link br1 nav-link-clr ${activecoTab === 'tab6' ? 'active' : ''}`}
                                id="sell-tab"
                                type="button"
                                role="tab"
                                onClick={() => handleCoTabClick('tab6')}

                              >
                                Sem 6
                              </button>
                            </li>
                            <li className="nav-item" role="presentation">
                              <button
                                className={`nav-link br1 nav-link-clr ${activecoTab === 'tab7' ? 'active' : ''}`}
                                id="sell-tab"
                                type="button"
                                role="tab"
                                onClick={() => handleCoTabClick('tab7')}

                              >
                                Sem 7
                              </button>
                            </li>
                            <li className="nav-item" role="presentation">
                              <button
                                className={`nav-link br1 nav-link-clr ${activecoTab === 'tab8' ? 'active' : ''}`}
                                id="sell-tab"
                                type="button"
                                role="tab"
                                onClick={() => handleCoTabClick('tab8')}

                              >
                                Sem 8
                              </button>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className="card-body pt-0">
                      <div className="tab-content st-tab-content" id="myTabContent">
                        <div className={`tab-pane fade ${activecoTab ? 'show active' : ''}`} id="all" role="tabpanel" aria-labelledby="all-tab">
                          <div className="table-responsive">
                            {isArray(tabRows[activecoTab]) && tabRows[activecoTab]?.length > 0 ? (
                              <table className="table table-striped">
                                <thead className="table-dark">
                                  <tr>
                                    <th scope="col" style={{ border: '1px solid white' }}>Sl No.</th>
                                    <th scope="col" style={{ border: '1px solid white' }}>Discipline Name</th>
                                    <th scope="col" style={{ border: '1px solid white' }}>Course Code</th>
                                    <th scope="col" style={{ border: '1px solid white' }}>Course Name</th>
                                    <th scope="col" style={{ border: '1px solid white' }}>Status</th>
                                    <th scope="col" width="15%" style={{ border: '1px solid white' }}>College Opted</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {tabRows[activecoTab].map((course, index) => (
                                    <tr key={index}>
                                      <td>{index + 1}</td>
                                      <td>{course.discipline_name ? course.discipline_name : "-"}</td>
                                      <td>{course.course_code ? course.course_code : "-"}</td>
                                      <td>{course.paper_identifier} - {course.course_name ? course.course_name : "-"}</td>
                                      <td>{course.studentstatus}</td>
                                      <td>
                                        <span
                                          style={{
                                            backgroundColor: course.student_type === 'Own College' ? 'green'
                                              : course.student_type === 'Other College' ? 'red'
                                                : 'none',
                                            color: course.student_type === "-" ? 'black' : 'white',
                                            padding: '2px 5px', // Apply padding around the text only
                                            borderRadius: '3px' // Optional: to make it look nicer with rounded corners
                                          }}
                                        >
                                          {course.student_type}
                                        </span>
                                      </td>

                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            ) : (
                              <p>Currently, the candidate has not registered for any courses</p>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
              <div className="row m-b-20">

                <div className="col-xl-12 col-sm-12 col-xxl-12">
                  <div className="card">
                    <div className="card-header">
                      <h4>Qualifications</h4>
                    </div>
                    <div className="card-body">
                      <div className="table-responsive">
                        <div className="st-bx-bod ">
                          <table className="table st-table-hover align-middle mobile-table table-bordered">
                            <thead className="table-dark">
                              <tr>
                                <th scope="col" width="7%">Sl No.</th>
                                <th scope="col" width="10%">Examination</th>
                                <th scope="col" width="30%">Name of Board</th>
                                <th scope="col" width="15%">Stream/Group</th>
                                <th scope="col" width="20%">No. of chances availed</th>
                                <th scope="col" width="20%">Year of passing</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td data-label="Sl No.">1</td>
                                <td data-label="Examination">{studentdata.qualifying_exam}</td>
                                <td data-label="Name of Board">
                                  {studentdata.board_name}
                                  {/* <button
                      className="btn btn-link text-decoration-none st-toggle-btn"
                      onClick={toggleAccordion}
                    > <span className="toggle-text">
                    {isAccordionOpen ? "Hide Details" : "View Details"}
                  </span>
                      {isAccordionOpen ? (
                        <i className="bi bi-chevron-up"></i>
                      ) : (
                        <i className="bi bi-chevron-down"></i>
                      )}
                    </button> */}
                                </td>
                                <td data-label="Stream/Group">{studentdata.stream}</td>
                                <td data-label="No. of chances availed">{studentdata.no_of_chances}</td>
                                <td data-label="Year of passing">{studentdata.year_of_passing}</td>
                              </tr>
                              <tr>
                                <td>
                                </td>
                                <td>
                                </td>

                                <td colSpan={3}>
                                  <button
                                    className="btn btn-link text-decoration-none st-toggle-btn"
                                    onClick={toggleAccordion}
                                  > <span className="toggle-text">
                                      {isAccordionOpen ? "Hide Marks" : "View Marks"}
                                    </span>
                                    {isAccordionOpen ? (
                                      <i className="bi bi-chevron-up"></i>
                                    ) : (
                                      <i className="bi bi-chevron-down"></i>
                                    )}
                                  </button>
                                </td>
                              </tr>

                            </tbody>
                          </table>
                          {isAccordionOpen && (
                            <div className="st-expanded-section m-15">
                              <h6 className="st-bx-h">Detailed Subject Scores</h6>
                              <div className="row">
                                {Array.isArray(markDetails) &&
                                  markDetails.length > 0 &&
                                  markDetails.map((mark, index) => (
                                    <React.Fragment key={index}>
                                      {mark?.first_language_name && (
                                        <div className="col-md-4 mb-3">
                                          <div className="card h-100 shadow st-hover-card">
                                            <div className="card-body d-flex flex-column justify-content-center">
                                              <h6 className="card-title text-primary">{mark.first_language_name}</h6>
                                              <p className="card-text" style={{ verticalAlign: 'middle' }}>
                                                <strong>Score:</strong> {mark.first_language_scoredmark}/
                                                {mark.first_language_totalmark}
                                              </p>
                                            </div>
                                          </div>
                                        </div>
                                      )}
                                      {mark?.second_language_name && (
                                        <div className="col-md-4 mb-3">
                                          <div className="card h-100 shadow st-hover-card">
                                            <div className="card-body d-flex flex-column justify-content-center">
                                              <h6 className="card-title text-primary">{mark.second_language_name}</h6>
                                              <p className="card-text">
                                                <strong>Score:</strong> {mark.second_language_scoredmark}/
                                                {mark.second_language_totalmark}
                                              </p>
                                            </div>
                                          </div>
                                        </div>
                                      )}
                                      {mark?.option1_name && (
                                        <div className="col-md-4 mb-3">
                                          <div className="card h-100 shadow st-hover-card">
                                            <div className="card-body d-flex flex-column justify-content-center">
                                              <h6 className="card-title text-primary">{mark.option1_name}</h6>
                                              <p className="card-text">
                                                <strong>Score:</strong> {mark.option1_scoredmark}/
                                                {mark.option1_totalmark}
                                              </p>
                                            </div>
                                          </div>
                                        </div>
                                      )}
                                      {mark?.option2_name && (
                                        <div className="col-md-4 mb-3">
                                          <div className="card h-100 shadow st-hover-card">
                                            <div className="card-body d-flex flex-column justify-content-center">
                                              <h6 className="card-title text-primary">{mark.option2_name}</h6>
                                              <p className="card-text">
                                                <strong>Score:</strong> {mark.option2_scoredmark}/
                                                {mark.option2_totalmark}
                                              </p>
                                            </div>
                                          </div>
                                        </div>
                                      )}
                                      {mark?.option3_name && (
                                        <div className="col-md-4 mb-3">
                                          <div className="card h-100 shadow st-hover-card">
                                            <div className="card-body d-flex flex-column justify-content-center">
                                              <h6 className="card-title text-primary">{mark.option3_name}</h6>
                                              <p className="card-text">
                                                <strong>Score:</strong> {mark.option3_scoredmark}/
                                                {mark.option3_totalmark}
                                              </p>
                                            </div>
                                          </div>
                                        </div>
                                      )}
                                      {mark?.option4_name && (
                                        <div className="col-md-4 mb-3">
                                          <div className="card h-100 shadow st-hover-card">
                                            <div className="card-body d-flex flex-column justify-content-center">
                                              <h6 className="card-title text-primary">{mark.option4_name}</h6>
                                              <p className="card-text">
                                                <strong>Score:</strong> {mark.option4_scoredmark}/
                                                {mark.option4_totalmark}
                                              </p>
                                            </div>
                                          </div>
                                        </div>
                                      )}
                                      {mark?.option5_name && (
                                        <div className="col-md-4 mb-3">
                                          <div className="card h-100 shadow st-hover-card">
                                            <div className="card-body d-flex flex-column justify-content-center">
                                              <h6 className="card-title text-primary">{mark.option5_name}</h6>
                                              <p className="card-text">
                                                <strong>Score:</strong> {mark.option5_scoredmark}/
                                                {mark.option5_totalmark}
                                              </p>
                                            </div>
                                          </div>
                                        </div>
                                      )}
                                    </React.Fragment>
                                  ))}
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>


            </>
          ) : (
            <div className="row  m-b-20">

              <div className="col-xl-12 col-sm-12 col-xxl-12">
                <div className="card  d-flex justify-content-center align-items-center pdg11">



                  <div class="card-body">
                    <div class="table-responsive">

                      <h5 className="card-title txt-aln mb-0">Student details not available</h5>



                    </div>
                  </div>

                </div>
              </div>
            </div>
          )}
        </div>



      </Template >
    </>
  );
};

export default StudentProfile;
